(function () {
  function getHeaderOffset() {
    const announceBar = document.querySelector('.announcement-bar-section');
    const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
    const announceHeight = announceBar ? announceBar.clientHeight : 0;
    const headerHeight = header ? header.clientHeight : 0;
    return announceHeight + headerHeight + 10;
  }

  function scrollToTarget(selector) {
    if (!selector) return;

    const target = document.querySelector(selector);
    if (!target) return;

    const top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top, behavior: 'smooth' });
  }

  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-banner-scroll-target]');
    if (!button) return;

    e.preventDefault();
    scrollToTarget(button.getAttribute('data-banner-scroll-target'));
  });
})();
